module.exports = __webpack_public_path__ + "static/media/05.51a61b21.gif";